import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
    import { fetchTHGUsers } from '@/api/thg/users';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { debounce } from 'lodash';
    import { THGUserType } from '@/enums/thg/THGUserType';

    interface Props {
        value: THGUser;
        labelText: string;
        placeholder: string;
        required: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUserAutoComplete',
  props: {
    value: null,
    labelText: null,
    placeholder: null,
    required: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        // eslint-disable-next-line no-unused-vars
        (e: 'input', value: THGUser | undefined): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        value: THGUser;
        labelText: string;
        placeholder: string;
        required: boolean;
    };

    

    

    const data = ref<THGUser[]>([]);
    const isFetching = ref<boolean>(false);

    function formatDisplay(option: THGUser) {
        if (option.type === THGUserType.COMPANY) {
            return `${option.company_name} - ${option.email}`;
        }

        return `${option.first_name} ${option.last_name} - ${option.email}`;
    }

    const retrieveData = debounce(async (query: string) => {
        isFetching.value = true;

        const resultByEMail = await fetchTHGUsers({
            is_verified: true,
            email: query,
        });

        const resultByName = await fetchTHGUsers({
            is_verified: true,
            name: query,
        });

        if (!resultByEMail.parsedBody || !resultByName.parsedBody) {
            throw new Error('Cannot retrieve users');
        }

        // make temporary list and query by email and by name
        const tempData: THGUser[] = [];

        if (Array.isArray(resultByEMail.parsedBody)) {
            tempData.push(...resultByEMail.parsedBody);
        }

        if (Array.isArray(resultByName.parsedBody)) {
            tempData.push(...resultByName.parsedBody);
        }

        // make the list unique by mail address
        // https://fullstackheroes.com/tutorials/javascript/5-ways-to-remove-duplicate-objects-from-array-based-on-property/
        data.value = [...new Map(tempData.map((v) => [v.email, v])).values()];

        isFetching.value = false;
    }, 500);

return { __sfc: true,props, emit, data, isFetching, formatDisplay, retrieveData }
}

})